

export const booksRoutes = [
    {   path: '/books', 
        component: () => import('../../views/BooksListView.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/books/addbook',
        name: 'addbook',
        component: () => import('../../views/BookForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/books/searchbook',
        name: 'searchbook',
        component: () => import('../../views/BookSearchForm.vue'),
        meta: { requiresAuth: true }
      },
]